export default "__VITE_ASSET__B_EXM49D__"